import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/MarketPlace/QuotationHistory.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { connect } from 'react-redux';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import filterIcon from '../../../Assets/TerminalHandling/filter-icon.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_REQUEST_SUMMARY_ENDPOINT } from '../../../Services/config/apiEndPoints';
class QuotationHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            search: "",
            searchlength: 0,
            quotationHisTempData: [],
            errorMessage: false,
            apiDataError: false,
            fliterValue: 'All',
            fliterValueDropDown: false,
            tempDataEmpty: true,
            quotationHisTempDataSearch: [],
            filterDataValues: [],
            openFilterEmptySearchState: [],
            closedFilterEmptySearchState: [],
            quotationHisDetails: []
        }
        this.handlechangeSearchAppointmentNo = this.handlechangeSearchAppointmentNo.bind(this);
    }
    filterDataValues = [{ name: "All" }, { name: "Open" }, { name: "Closed" }]
    componentDidMount = () => {
        this.getQuotationHistory();
    }
    getQuotationHistory = () => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_REQUEST_SUMMARY_ENDPOINT + `?roleType=Requester`,
            //  serviceBaseURL + SERVICE_REQUEST_SUMMARY_ENDPOINT + `?roleType=${this.props.manageProfileDataR?.selectedProfileType}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                    this.setState({ errorMessage: true, apiDataError: true });
                }
                else {
                    console.log('I am 200!');
                    this.setState({ quotationHisDetails: apiData })
                }
            }
        });
    }
    handleDetails = (index) => {
        this.state.quotationHisTempData.find((name) => {
            if (name.serviceRequestId == this.state.quotationHisTempData[index].serviceRequestId && name?.serviceDetail?.serviceType == 'Transportation') {
                this.props.history.push({
                    pathname: `/TransportationService/${name.serviceRequestId}/${name?.serviceDetail?.serviceType}`,
                });
            }
            else if (name.serviceRequestId == this.state.quotationHisTempData[index]?.serviceRequestId) {
                this.props.history.push({
                    pathname: `/TransportationServiceGS/${name?.serviceRequestId}/${name?.serviceDetail?.serviceType}`,
                });
            }
        })
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ fliterValueDropDown: false });
        }
    };
    toggleDropdownCargoPackaging = () => {
        this.setState({ fliterValueDropDown: !this.state.fliterValueDropDown });
    };
    openFilterEmptySearch = [];
    openFilter = [];
    closedFilterEmptySearch = [];
    closedFilter = [];
    truckdatafilterAll = [];
    truckdatafilterOpen = [];
    truckdatafilterClosed = [];
    errorMessageDisplayFunction = (dataValue) => {
        if (dataValue.length === 0) {
            this.setState({ errorMessage: true });
        }
        else {
            this.setState({ errorMessage: false });
        }
    }
    changeFilterValue = (event) => {
        const found = this.filterDataValues.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ fliterValue: found.name });
        this.setState({ fliterValueDropDown: !this.state.fliterValueDropDown });
        if (found.name == 'Open') {
            if (this.state.tempDataEmpty) {
                this.openFilterEmptySearch = this.state.quotationHisDetails.filter(i => i.serviceDetail?.status == 'Open')
                console.log('abc--', this.openFilterEmptySearch)
                this.setState({
                    quotationHisTempData: this.openFilterEmptySearch,
                    openFilterEmptySearchState: this.openFilterEmptySearch
                })
                this.errorMessageDisplayFunction(this.openFilterEmptySearch);
            } else {
                this.openFilter = this.state.quotationHisTempDataSearch.filter(i => i.serviceDetail?.status == 'Open')
                console.log('abc--', this.openFilter)
                this.setState({
                    quotationHisTempData: this.openFilter
                })
                this.errorMessageDisplayFunction(this.openFilter);
            }
        } else if (found.name == 'Closed') {
            if (this.state.tempDataEmpty) {
                this.closedFilterEmptySearch = this.state.quotationHisDetails.filter(i => i.serviceDetail?.status == 'Closed')
                console.log('abc----', this.closedFilterEmptySearch)
                this.setState({
                    quotationHisTempData: this.closedFilterEmptySearch,
                    closedFilterEmptySearchState: this.closedFilterEmptySearch
                })
                this.errorMessageDisplayFunction(this.closedFilterEmptySearch);
            } else {
                this.closedFilter = this.state.quotationHisTempDataSearch.filter(i => i.serviceDetail?.status == 'Closed')
                console.log('abc----', this.closedFilter)
                this.setState({
                    quotationHisTempData: this.closedFilter
                })
                this.errorMessageDisplayFunction(this.closedFilter);
            }
        }
        else {
            if (this.state.tempDataEmpty) {
                this.setState({
                    quotationHisTempData: this.state.quotationHisDetails
                })
                this.errorMessageDisplayFunction(this.state.quotationHisDetails);
            } else {
                this.setState({
                    quotationHisTempData: this.state.quotationHisTempDataSearch
                })
                this.errorMessageDisplayFunction(this.state.quotationHisTempDataSearch);
            }
        }
    }
    handlechangeSearchAppointmentNo = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value.length,
            errorMessage: false,
        });
    };
    searchByOrderId = () => {
        if (this.state.searchlength > 0) {
            this.truckdatafilterAll = this.state.quotationHisDetails.filter(i => i.serviceRequestId == this.state.search)
            this.setState({ quotationHisTempDataSearch: this.truckdatafilterAll });
            if (this.state.fliterValue === 'All') {
                console.log('a---', this.truckdatafilterAll);
                this.setState({ quotationHisTempData: this.truckdatafilterAll });
                if (this.truckdatafilterAll.length === 0) {
                    this.setState({ tempDataEmpty: true, errorMessage: true });
                }
                else {
                    this.setState({ tempDataEmpty: false, errorMessage: false });
                }
            }
            if (this.state.fliterValue === 'Open') {
                this.truckdatafilterOpen = this.openFilterEmptySearch.filter(i => i.serviceRequestId == this.state.search)
                console.log('a---', this.truckdatafilterOpen);
                this.setState({ quotationHisTempData: this.truckdatafilterOpen });
                if (this.truckdatafilterOpen.length === 0) {
                    this.setState({ tempDataEmpty: true, errorMessage: true });
                }
                else {
                    this.setState({ tempDataEmpty: false, errorMessage: false });
                }
            }
            if (this.state.fliterValue === 'Closed') {
                this.truckdatafilterClosed = this.closedFilterEmptySearch.filter(i => i.serviceRequestId == this.state.search)
                console.log('a---', this.truckdatafilterClosed);
                this.setState({ quotationHisTempData: this.truckdatafilterClosed });
                if (this.truckdatafilterClosed.length === 0) {
                    this.setState({ tempDataEmpty: true, errorMessage: true });
                }
                else {
                    this.setState({ tempDataEmpty: false, errorMessage: false });
                }
            }
            console.log("inside search function", this.state.quotationHisTempData);
        }
    }
    render() {
        if (this.state.searchlength == 0 && this.state.fliterValue === 'All') {
            this.state.quotationHisTempData = this.state.quotationHisDetails;
        }
        if (this.state.searchlength == 0 && this.state.fliterValue === 'Open') {
            this.state.quotationHisTempData = this.state.openFilterEmptySearchState;
        }
        if (this.state.searchlength == 0 && this.state.fliterValue === 'Closed') {
            this.state.quotationHisTempData = this.state.closedFilterEmptySearchState;
        }
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.QuotationHistoryTitle} description={TitleDescription.QuotationHistoryDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullTruckAppointment">
                    <div id="csnobox111">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Service Request History</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="QuotationHisMainCard">
                            {!this.state.apiDataError &&
                                <div class="QuotationHisSearchUprDiv">
                                    <div class="QuotationHisSearchDiv">
                                        <input
                                            className="appointmentSearch"
                                            placeholder="Search by Service Request ID"
                                            autoComplete="off"
                                            id="quotationHisDropDownCss"
                                            onChange={this.handlechangeSearchAppointmentNo}
                                            value={this.state.search}
                                        ></input>
                                        <img onClick={this.searchByOrderId} id="QuotationFilter_imgDrop" src={searchimg} width="16" height="16" />
                                    </div>
                                    <div class="QuotationFilterDiv">
                                        <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                            <Input
                                                readOnly name="CargoPackaging" class="input" placeholder=""
                                                type="text" id="quotationHisDropDownCss" value={this.state.fliterValue}
                                            />
                                            <i id="Quotation_imgDrop" onClick={this.toggleDropdownCargoPackaging}>
                                                <img src={filterIcon} />
                                            </i>
                                        </div>
                                        {this.state.fliterValueDropDown && (
                                            <div class="CrtTptReqestDropDowmDiv" >
                                                <div class="CrtTptReqestDropCard" ref={this.container} >
                                                    {(this.filterDataValues.map((name, index) => {
                                                        return (
                                                            <DropDownTable onClick={(val) => this.changeFilterValue(val)} id="CrtTptReqestDropRowSize">
                                                                <small class="" id="CrtTptReqestDropRowText" >{name.name} </small>
                                                            </DropDownTable>
                                                        );
                                                    }))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            <div id="QuotationHisTopDiv">
                                {!this.state.errorMessage ?
                                    (this.state.quotationHisTempData.map((name, index) => {
                                        return (
                                            <div class="QuotationHisMainCardDiv" onClick={() => this.handleDetails(index)}>
                                                <div class="QuotationHisDivRow" >
                                                    <div class="QuotationHisMainColumn1">
                                                        <div class='QuotationHisMainColumn' id='QuotationDiv1'>
                                                            <small id="QuotationHisLable">Service Request ID</small>
                                                            <small id='QuotationHisValue'>{name.serviceRequestId}</small>
                                                        </div>
                                                        <div class='QuotationHisMainColumn' id='QuotationDiv2'>
                                                            <small id="QuotationHisLable">Service Request Date & Time</small>
                                                            <small id='QuotationHisValue'>{FormatTimeStamp(name?.serviceDetail?.publishDateTime).timedateToLocale}</small>
                                                        </div>
                                                        <div class='QuotationHisMainColumn' id='QuotationDiv3'>
                                                            <small id="QuotationHisLable">Service Type</small>
                                                            <small id='QuotationHisValue'>{name?.serviceDetail?.serviceType}</small>
                                                        </div>
                                                        <div class='QuotationHisMainColumn' id='QuotationDiv4'>
                                                            <small id="QuotationHisLable">Status</small>
                                                            <small id={name?.serviceDetail?.status == 'Open' ? 'QuotationHisValueGreen' : "QuotationHisValue"}>{name?.serviceDetail?.status}</small>
                                                        </div>
                                                    </div>
                                                    <div class="QuotationHisArrow" >
                                                        <img src={rightarrow} id="rightarrowimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }))
                                    :
                                    <div class="NoQuotationHistory">
                                        <small id="nodatamessage1">No result found</small>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="QuotationHistoryFooter1">
                    <Footer />
                </div>
                <div class="QuotationHistoryFooter2">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        manageProfileDataR: state.manageProfileReducer.data
    }
}
export default connect(mapStateToProps)(QuotationHistory);